import { Map } from 'immutable'
import { GET_EVENTS_SUCCESS } from '../actions/ActionTypes'

const unopenedEvents = (state = Map(), action) => {
  switch (action.type) {
    case GET_EVENTS_SUCCESS:
      return state.mergeDeep(action.data.unopenedEvents)
    default:
      return state
  }
}

export default unopenedEvents
